import {
  computed,
  onBeforeUnmount,
  onMounted,
  ref,
  readonly,
} from '@nuxtjs/composition-api';
import CookieNames from '@/constants/CookieNames';
import Analytics from '@/services/Analytics';
import Cookie from 'js-cookie';
import Contentful, { ContentfulTypes } from '@/services/Contentful';
import detectMobileDevice from '@/utils/detectMobileDevice';
import exitIntent from 'exit-intent';

const VARIANT = 'trustbambee';
const EVENT_NAME = 'abandonment-overlay-shown';
const DELAY = 40000;

export const content = ref(null);
const isOverlayActive = ref(false);

const showOverlay = (eventTrigger) => {
  isOverlayActive.value = true;
  Cookie.set(CookieNames.EXIT_INTENT, eventTrigger);
  Analytics.track(EVENT_NAME, { eventTrigger, show: true });
};

const hideOverlay = () => {
  isOverlayActive.value = false;
};
const isOverlayVisible = computed(
  () => !!(isOverlayActive.value && content.value)
);

let timeout;

const useAbandonmentOverlay = () => {
  onMounted(() => {
    const hasSeenOverlay = !!Cookie.get(CookieNames.EXIT_INTENT);
    const isMobile = detectMobileDevice();

    if (!hasSeenOverlay && !isMobile && !timeout) {
      if (!content.value) {
        (async () => {
          const res = await Contentful.getEntries({
            content_type: ContentfulTypes.TEST_ABANDONMENT_OVERLAY,
            'fields.variant[match]': VARIANT,
          });
          content.value = res.items[0]?.fields;
        })();
      }
      timeout = setTimeout(() => {
        showOverlay('timer-desktop');
      }, DELAY);

      exitIntent({
        threshold: 50,
        maxDisplays: 1,
        eventThrottle: 100,
        onExitIntent: () => {
          showOverlay('cursor-abandon');
          clearTimeout(timeout);
        },
      });

      onBeforeUnmount(() => {
        clearTimeout(timeout);
      });
    }
  });

  return {
    content: readonly(content),
    hideOverlay,
    isOverlayVisible,
  };
};

export default useAbandonmentOverlay;
